import { render, staticRenderFns } from "./PolicyDocumentsLog.vue?vue&type=template&id=59f1d2ee&"
import script from "./PolicyDocumentsLog.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentsLog.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDocumentsLog.vue?vue&type=style&index=0&id=59f1d2ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports